import { http, HttpResponse } from 'msw'

import { type TutorialStatusApiModel } from '../api-models/TutorialStatusApiModel'

const DEFAULT_TUTORIAL_STATUS: TutorialStatusApiModel = {
  approval: { punchout_confirmation: 0 },
}

export const mockGetTutorialStatusSuccess = (
  data: TutorialStatusApiModel = DEFAULT_TUTORIAL_STATUS
) => {
  return http.get(
    '/api/tutorial/',
    () => {
      return HttpResponse.json(data, { status: 200 })
    },
    { once: true }
  )
}
